import React, { useState, useEffect } from "react";
import { Button } from 'primereact/button';
import { Fieldset } from 'primereact/fieldset';
import { InputText } from 'primereact/inputtext';
import { useFormik } from "formik";
import { InputTextarea } from 'primereact/inputtextarea';
import { allocationService } from "../../../services";
import moment from "moment";
const UpdateProjectMilestone = ({ onClose, milestoneData }) => {
  const [currentPercentage, setCurrentPercentage] = useState('');

  useEffect(() => {
    const sortedMilestone = milestoneData.projectMilestone.sort((a, b) => b.id - a.id);
    setCurrentPercentage(sortedMilestone[0].percentage);
    formik.setFieldValue('percentage', sortedMilestone[0].percentage);
  }, []);

  const formik = useFormik({
    initialValues: {
      percentage: "",
      description: "",
    },
    validate: (data) => {
      let errors = {};
      if (!data.percentage) {
        errors.percentage = "Percentage is required.";
      }
      if (data.percentage > 100) {
        errors.percentage = "Percentage should be equal or less than 100.";
      }
      // if (data.percentage < currentPercentage) {
      //   errors.description = 'Description is required';
      // }
      if (!data.description) {
        errors.description = 'Description is required';
      }
      return errors;
    },
    onSubmit: (data) => {
      let params = {
        milestoneId: milestoneData.id,
        date: moment(new Date()).format("YYYY-MM-DD"),
        percentage: data.percentage,
        description: data.description,
        userId: 158,
      };
      if(data.percentage == 100){
        params.status = 1
      }
      console.log(data, "Save Data", params)
      try {
        allocationService.updateProjectMilestone1(params).then(
          (resp) => {
            // toast.info("Timesheet created successfully...");
          },
          (resp) => {
            // toast.error(resp.response.data.error);
          }
        );
      } catch (error) {
        // toast.error("Unable to create timesheet...");
      }
      // }
    },
  });

  const isFormFieldValid = (name) =>
    !!(formik.touched[name] && formik.errors[name]);
  const getFormErrorMessage = (name) => {
    return (
      isFormFieldValid(name) && (
        <small className="p-error">{formik.errors[name]}</small>
      )
    );
  };


  return (
    <Fieldset legend="Update Milestone Status">
      <form onSubmit={formik.handleSubmit} className="p-fluid p-grid">
        <div className="col grid">
          <div className="col-4 mt-2">
            <strong style={{ fontSize: '16px', fontWeight: '400' }}>Current Status(%)</strong>
          </div>
          <div className="col-3">
            <InputText max={100} value={formik.values.percentage} onChange={formik.handleChange} className='inputPercentage' id="percentage" name="percentage" />
          </div>
          <div className="col-2"></div>
          {getFormErrorMessage("percentage")}
        </div>
        <div className="col grid">
          <div className="col-4 mt-2">
            <strong style={{ fontSize: '16px', fontWeight: '400' }}>Description</strong>
          </div>
          <div className="col-7">
            <InputTextarea id="description" name="description" autoResize value={formik.values.description} onChange={formik.handleChange} />
          </div>
          {getFormErrorMessage('description')}
        </div>
        <div className="mr-7" style={{ float: 'right' }}>
          <Button type="submit" label="SAVE" />
        </div>
      </form>
    </Fieldset>
  );
};
export default UpdateProjectMilestone;
